<template>
  <div class="wrapper-padding sp-padding">
    <b-container fluid class="h-100">
      <main class="row align-items-center h-100 mt-4">
        <div class="text-center mx-auto">
          <h1>404 Not Found</h1>
          <p class="mb-4">該当するページが存在しませんでした</p>
          <b-button class="w-100" style="max-width: 200px;" variant="secondary" @click="$router.go(-1)">戻る</b-button>
        </div>
      </main>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'notFound',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
</style>
